module.exports = __webpack_public_path__ + "static/media/logo-black.be275f01.png";